import config from "../config/app.conf.json";

export default () => ({
  url: `${config.api.permissions_service_url}/roles?type=platform`,
  method: "GET"
});